import { getPanelToIslandResolver, type Panel, type PanelItem, type PanelItemGroup } from '@rta/rta-blueprint-library';

export type CutoutWorldPosition = {
	x: number;
	z: number;
};

// Resolves a panelItem's cutout center into the same unrotated, island-local frame the
// countertop's own furniture (CLEAN EDGE labels, the page notes/footer) is positioned in.
export const getCutoutWorldPosition = (panel: Panel, group: PanelItemGroup, panelItem: PanelItem): CutoutWorldPosition => {
	const { x: groupX, z: groupZ } = group.center;
	const { x: itemX, z: itemZ } = panelItem.center;
	const resolveToIsland = getPanelToIslandResolver(panel);
	return resolveToIsland(groupX + itemX, groupZ + itemZ);
};
